/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/genes' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/GeneLink.js